import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { getImageUrl } from '@utils/getImageUrl'
import { t } from '@lingui/core/macro'

const Container = styled.div`
  min-height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  div:first-of-type {
    margin-bottom: 15px;
  }
`

const img = css`
  width: 225px;
`

export const EmptyState = () => {
  return (
    <Container>
      <div>
        <img
          css={img}
          src={getImageUrl('undraw_Done_checking', 'svg')}
          alt={t`No approval requests`}
        />
      </div>
      <div>
        <Typography variant="h4">{t`No approval requests found`}</Typography>
      </div>
    </Container>
  )
}
